import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  Box,
  Stack,
} from "@mui/material";
import { useState, useEffect } from "react";

export type PointOfInterestData = {
  title: string;
  description: string;
  lat: number;
  lng: number;
};

interface PointModalProps {
  open: boolean;
  onClose: () => void;
  location: { lat: number; lng: number };
  mode: "view" | "edit" | "create";
  data?: PointOfInterestData;
  onSubmit: (data: PointOfInterestData) => void;
}

interface PointModalProps {
  open: boolean;
  onClose: () => void;
  location: { lat: number; lng: number };
  mode: "view" | "edit" | "create";
  data?: PointOfInterestData;
  onSubmit: (data: PointOfInterestData) => void;
  onDelete?: () => void;
}

const PointModal: React.FC<PointModalProps> = ({
  open,
  onClose,
  location,
  mode,
  data,
  onSubmit,
  onDelete,
}) => {
  const [editMode, setEditMode] = useState(
    mode === "edit" || mode === "create"
  );
  const [title, setTitle] = useState(data?.title || "");
  const [description, setDescription] = useState(data?.description || "");

  useEffect(() => {
    if (open) {
      setTitle(data?.title || "");
      setDescription(data?.description || "");
      setEditMode(mode === "edit" || mode === "create");
    }
  }, [open, data, mode]);

  const handleSave = () => {
    onSubmit({ title, description, lat: location.lat, lng: location.lng });
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 3,
          padding: 1,
          minWidth: 400,
        },
      }}
    >
      <DialogTitle>
        {mode === "create"
          ? "Lisää uusi piste"
          : editMode
          ? "Muokkaa pistettä"
          : "Pistetiedot"}
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          <TextField
            label="Otsikko"
            fullWidth
            variant="outlined"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            disabled={!editMode}
          />
          <TextField
            label="Kuvaus"
            fullWidth
            variant="outlined"
            multiline
            rows={4}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            disabled={!editMode}
          />
          <Box>
            <Typography variant="subtitle2" gutterBottom>
              Sijainti
            </Typography>
            <Typography variant="body2">
              Lat: {location.lat.toFixed(5)}
              <br />
              Lng: {location.lng.toFixed(5)}
            </Typography>
          </Box>
        </Stack>
      </DialogContent>
      <DialogActions>
        {editMode ? (
          <>
            <Button onClick={onClose} color="inherit">
              Peruuta
            </Button>
            <Button onClick={handleSave} variant="contained" disabled={!title}>
              {mode === "create" ? "Lisää piste" : "Tallenna"}
            </Button>
          </>
        ) : (
          <>
            <Button onClick={onClose} color="inherit">
              Sulje
            </Button>
            <Button onClick={() => setEditMode(true)} variant="outlined">
              Muokkaa
            </Button>
            {onDelete && (
              <Button
                onClick={() => {
                  onDelete();
                  onClose();
                }}
                color="error"
                variant="contained"
              >
                Poista
              </Button>
            )}
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default PointModal;
